module.exports = __webpack_public_path__ + "static/media/diagram.e2446bf8.svg";